import API from '@/services/api.service'

const OrderAPI = {
  post (data) {
    return API.post('incoming_orders', data).catch(error => {
      return Promise.reject(error)
    })
  }
}

export default OrderAPI
